import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AppGlobalsServiceBase, CustomerSelectComponent, Job, LU_MaterialService, STContact, Invoice, ScaleTicketStatusEnum, StarbaseServicesProviderBase, } from 'scaletech-core';
import { IStarbaseNotificationObject, StarbaseNotificationTypes } from 'starbase-notification';
import { FilterParams } from 'starbase-launcher';
import { Observable, of, share } from 'rxjs';
import { STContactDataService } from '../services/st-contact-data.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { IUserTokenModel, StarbaseLoginService } from 'starbase-login';
import { IStarbaseWizardStep, StarbaseWizardStep } from 'starbase-wizard';


class ReportButton {
  text: string;
  icon: string;
  class: string;
  clickEvent: Function;
  tooltip: string;
  active: boolean;

  constructor(btnText = '', btnClass = 'btn-outline-secondary', btnClickEvent = undefined, active = false) {
    this.text = btnText;
    this.class = btnClass;
    this.clickEvent = btnClickEvent;
    this.active = active;
  }
}

@Component({
  selector: 'lib-transaction-report-wizard',
  templateUrl: './transaction-report-wizard.component.html',
  styleUrls: ['./transaction-report-wizard.component.css'],
  standalone: false
})
export class TransactionReportWizardComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() darkMode = false;
  @Input() glassMode = false;
  @Input() iconClass: string;
  @Input() iconColor: string;
  @Input() contactSvc: STContactDataService;
  @Input() sbSvcProvider: StarbaseServicesProviderBase;
  @Input() appGlobals: AppGlobalsServiceBase;

  @ViewChild('customerSelect') customerSelect: CustomerSelectComponent;
  @ViewChild('step1', { static: true }) step1: TemplateRef<FilterParams<Invoice>>;
  @ViewChild('dateInput', { static: false }) dateInput: any;

  @Output() wizardCompletedEmitter = new EventEmitter<FilterParams<Invoice>>();
  @Output() wizardCancelledEmitter = new EventEmitter<any>();

  year: Date = null;
  filterCustomerUID = 0;
  filterStatus: ScaleTicketStatusEnum[] = [];
  filterDateFrom: Date = null;
  filterDateTo: Date = null;
  filterCustomer = '';
  isAdmin = false;
  private currentUser: IUserTokenModel;
  public dropdownTypeDebounceTime;


  customers: STContact[] = [];
  public showAll = true;
  public customersLoaded = true;
  public isProcessing = false;
  public filterParams: FilterParams<Invoice> = new FilterParams<Invoice>();
  public generateReportSteps: IStarbaseWizardStep<FilterParams<Invoice>>[];
  public filter = new FilterParams;
  statuses: any[] = [];
  materials: any[] = [];
  allCustomers: STContact[] = [];
  selectCustomerMode = false;
  selectJobMode = false;
  private now = new Date();
  private dateCustomClasses = [
    { date: this.now, classes: ['bg-info'] }
  ];
  bsConfig: Partial<BsDatepickerConfig> = {
    isAnimated: true,
    adaptivePosition: true,
    containerClass: 'theme-green',
    showPreviousMonth: true,
    showWeekNumbers: false,
    ranges: [
      {
        value: [new Date(new Date().setHours(0, 0, 0, 0)), new Date()],
        label: 'Today'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0)), new Date(new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999))],
        label: 'Yesterday'
      },
      {
        value: [new Date(new Date(new Date().setDate(new Date().getDate() - 7)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 7 Days'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth() - 6, 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Previous 6 Months'
      },
      {
        value: [new Date(new Date(new Date().setMonth(new Date().getMonth(), 1)).setHours(0, 0, 0, 0)), new Date()],
        label: 'Month To Date'
      },
      {
        value: [new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0), new Date()],
        label: 'Year To Date'
      }
    ],
    dateCustomClasses: this.dateCustomClasses
  };

  dateRangeString = '';
  customerString = '';
  currentMonth: number = new Date().getMonth();
  startYear: number = 2023;

  months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  reportableMonths: number[] = [
    this.currentMonth,
    this.currentMonth - 1 + (this.currentMonth - 1 < 0 ? 12 : 0),
    this.currentMonth - 2 + (this.currentMonth - 2 < 0 ? 12 : 0),
    this.currentMonth - 3 + (this.currentMonth - 3 < 0 ? 12 : 0),
    this.currentMonth - 4 + (this.currentMonth - 4 < 0 ? 12 : 0),
    this.currentMonth - 5 + (this.currentMonth - 5 < 0 ? 12 : 0),
    this.currentMonth - 6 + (this.currentMonth - 6 < 0 ? 12 : 0)
  ];

  reportableYears = [
    new Date().getFullYear(),
    new Date().getFullYear() - 1,
    new Date().getFullYear() - 2,
    new Date().getFullYear() - 3,
    new Date().getFullYear() - 4
  ];

  summaryDateFrom: Date = null;
  summaryDateTo: Date = null;
  reportMonthButtons: ReportButton[] = [
    new ReportButton(this.months[this.reportableMonths[0]], 'btn-outline-primary', () => this.setMonthDateRange(this.reportableMonths[0]), true),
    new ReportButton(this.months[this.reportableMonths[1]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[1]), true),
    new ReportButton(this.months[this.reportableMonths[2]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[2]), true),
    new ReportButton(this.months[this.reportableMonths[3]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[3]), true),
    new ReportButton(this.months[this.reportableMonths[4]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[4]), true),
    new ReportButton(this.months[this.reportableMonths[5]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[5]), true),
    new ReportButton(this.months[this.reportableMonths[6]], 'btn-outline-secondary', () => this.setMonthDateRange(this.reportableMonths[6]), true)
  ];
  reportYearButtons: ReportButton[] = [
    new ReportButton(this.reportableYears[0].toString(), 'btn-outline-primary', () => this.setYearDateRange(this.reportableYears[0]), true),
    new ReportButton(this.reportableYears[1].toString(), 'btn-outline-secondary', () => this.setYearDateRange(this.reportableYears[1]), true),
    new ReportButton(this.reportableYears[2].toString(), 'btn-outline-secondary', () => this.setYearDateRange(this.reportableYears[2]), true),
    new ReportButton(this.reportableYears[3].toString(), 'btn-outline-secondary', () => this.setYearDateRange(this.reportableYears[3]), true),
    new ReportButton(this.reportableYears[4].toString(), 'btn-outline-secondary', () => this.setYearDateRange(this.reportableYears[4]), true)
  ];

  constructor(private cd: ChangeDetectorRef, private loginSvc: StarbaseLoginService) { }

  ngOnInit(): void {

    this.generateReportSteps = [
      new StarbaseWizardStep(
        'Range Selection',
        this.step1,
        'auto'
      )
    ];

    this.generateReportSteps[0].stepValidationFunc = () => {
      this.generateReportSteps[0].stepValid$.next(/*!!this.filterDateFrom && !!this.filterDateTo &&*/ this.customersLoaded);
    };
    this.generateReportSteps[0].interStepFunc = (x: FilterParams<Invoice>) => {
      return of(void 0);
    }

    this.isAdmin = this.loginSvc.getUserModel().isAdmin();
    this.currentUser = this.loginSvc.getUserModel();
    if (!this.appGlobals.currentUser || this.appGlobals.currentUser !== this.currentUser.user) {
      this.appGlobals.currentUser = this.currentUser.user;
    }

    this.darkMode = this.appGlobals.getStoredDarkModeSetting();

    this.dropdownTypeDebounceTime = this.appGlobals.dropdownTypeDebounceTime;

    if (this.appGlobals.getStoredDarkModeSetting()) {
      this.bsConfig.containerClass = 'theme-default'
    }
    this.statuses = Invoice.GetStatusEnum();

    this.contactSvc.getCustomers().subscribe(c => {
      if (c && c.length) {
        this.allCustomers = c;
      }
    });

    setTimeout(() => {
      this.generateReportSteps[0].stepValidationFunc(null);
    }, 500)

  }

  ngOnDestroy() {

  }

  ngAfterViewInit(): void {
    this.dateInput.nativeElement.focus();
  }

  setDateFilters<T>(filters: FilterParams<T>) {
    if (this.filterDateFrom && this.filterDateTo) {
      filters.addToFilter('ScaleTicketDateInFrom', this.filterDateFrom.toISOString());
      filters.addToFilter('ScaleTicketDateInTo', this.filterDateTo.toISOString());
    }
  }

  generateReport(filters: FilterParams<Invoice>) {
    let temp = new FilterParams<Invoice>();
    Object.assign(temp, filters);
    this.filterParams = temp;
    this.filterParams = this.updateGeneralFilters(this.filterParams);
    this.filterParams = this.updateCustomerFilters(this.filterParams);
    this.filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.INVOICED.toString());
    this.filterParams.addToFilter('ScaleTicketStatus', ScaleTicketStatusEnum.UNBILLED.toString());

    this.wizardCompletedEmitter.emit(this.filterParams);
  }

  selectAllCustomers() {
    this.customers = this.allCustomers;
    this.customers.forEach(x => x.selected = true);

    if (this.customerSelect) {
      this.customerSelect.refreshData(this.customerSelect.filter, this.contactSvc.customerBroadSearchUri);
    }

    this.selectCustomerMode = false;
  }

  dateRangeChange(val: Date[]) {
    this.showAll = false;
    this.filterDateFrom = val[0];
    this.filterDateTo = val[1];

    if (this.filterDateFrom && this.filterDateTo) {
      this.dateRangeString = `${this.filterDateFrom.toLocaleDateString()} - ${this.filterDateTo.toLocaleDateString()}`;
    } else {
      this.dateRangeString = '';
    }

    if (this.filterDateFrom != null || this.filterDateTo != null) {
      this.filterDateFrom.setHours(0, 0, 0, 0);
      this.filterDateTo.setHours(23, 59, 59, 999);
    }
    if (this.filterDateFrom > this.filterDateTo) {
      this.sbSvcProvider.notificationSvc.postNotification(
        this.sbSvcProvider.notificationSvc.notificationBuilder(
          'Invalid Date Range',
          'Please enter a valid Date Range'
        ));
    } else {
      this.customers = this.customers;
    }
    if (this.filterParams == null) {
      this.filterParams = this.updateGeneralFilters(this.filterParams);
    }
    else {
      this.filterParams.clearFilterArray();
      this.filterParams = this.updateGeneralFilters(this.filterParams);
    }

    // this.updateCustomers();
    this.cd.detectChanges();
  }

  updateGeneralFilters(filters: FilterParams<Invoice>) {
    this.filterStatus.forEach(x => {
      filters.addToFilter('ScaleTicketStatus', x);
    });

    this.setDateFilters(filters);

    return filters;
  }

  updateCustomerFilters(filters: FilterParams<Invoice>) {
    if (this.customers == this.allCustomers) {
      return filters;
    }

    else {
      this.customers.forEach(x => {
        filters.addToFilter('Job.JobContactUID', x.contactUID);
      })
    }

    return filters;
  }

  updateCustomers() {
    this.customersLoaded = false;
    this.isProcessing = true;
    var filters = new FilterParams<STContact>();

    filters.rpp = 32760;

    this.setDateFilters(filters);

    if (this.filterStatus) {
      this.filterStatus.forEach(s => filters.addToFilter('ScaleTicketStatus', s));
    }

    const customerSearch$ = this.contactSvc.getDataByFilterParamsBroadSearch(this.contactSvc.customerBroadSearchUri, filters).pipe(share());
    const notifier = this.createAsyncNotification(customerSearch$);

    customerSearch$.subscribe(c => {
      this.customersLoaded = true;
      this.customers = c.collection;
      this.allCustomers = c.collection;
      notifier.updateTitle('Completed');
      this.isProcessing = false;
    });

    this.sbSvcProvider.notificationSvc.postNotification(notifier);
  }

  private createAsyncNotification(obs: Observable<any>): IStarbaseNotificationObject {
    let title = 'Please wait...';
    if (this.isProcessing) {
      title = 'Processing...';
    }

    return this.sbSvcProvider.notificationSvc.notificationBuilderAsync(
      title,
      null,
      StarbaseNotificationTypes.Notice,
      obs
    );
  }

  selectCustomer(customer: STContact) {
    if (customer) {
      this.customers = [];
      this.customers.push(customer);
      this.customerString = customer.organization;
    } else {
      this.customers = [];
      this.customerString = '';
    }
  }

  deselectCustomer() {
    this.customers = [];
    this.closeCustomerSelectComponent();
  }

  openCustomerSelection() {
    this.selectCustomerMode = true;
  }

  closeCustomerSelectComponent() {
    this.selectCustomerMode = false;
  }

  setMonthDateRange(month: number) {
    var date1 = new Date();
    date1.setMonth(month, 1);
    date1.setHours(0, 0, 0, 0);
    var date2 = new Date();
    date2.setMonth(month + 1, 0);
    date2.setHours(23, 59, 59, 999);
    this.dateRangeChange([date1, date2]);
  }

  setYearDateRange(year: number) {
    var date1 = new Date(year, 0, 1);
    date1.setHours(0, 0, 0, 0);
    var date2 = new Date(year, 11, 31);
    date2.setHours(23, 59, 59, 999);
    this.dateRangeChange([date1, date2]);
  }
}
